function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 8,
  fill: "#CCE6D8"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#2B9D8B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.636
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.455 24v-6.222M9.455 14.222V8M16 24v-8M16 12.444V8M22.545 24v-4.444M22.545 16V8M7 17.778h4.909M13.545 12.444h4.91M20.091 19.556H25"
})));

function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a62cf7fc.svg";
export { ForwardRef as ReactComponent };